import { ReactElement } from 'react';

import { SubGridItem } from '../SubGridItem';

import styles from './styles.module.scss';

import { widgetsConfig } from ':constants';

interface GridContainerProps {
  containerName: string;
}

export function GridContainer({
  containerName,
}: GridContainerProps): ReactElement {
  return (
    <div className={styles.gridContainer}>
      {widgetsConfig.map(({ id, container, ...rest }) =>
        container === containerName ? <SubGridItem key={id} {...rest} /> : null
      )}
    </div>
  );
}
